var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "join-row-wrap"
  }, [_c('div', {
    staticClass: "join-row join-row--form"
  }, [_vm._m(0), _c('div', {
    staticClass: "join-table",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('myinfo-row', {
    attrs: {
      "label": "아이디"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.username,
      expression: "user.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": _vm.user.username
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.user, "username", $event.target.value);
      }, _vm.input]
    }
  })]), _c('myinfo-row', {
    attrs: {
      "label": "비밀번호"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  }), _c('small', {
    staticClass: "text-grey text-grey--right"
  }, [_vm._v("(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)")])], 1), _c('myinfo-row', {
    attrs: {
      "label": "비밀번호 확인"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.passwordConfirm,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "passwordConfirm", $$v);
      },
      expression: "user.passwordConfirm"
    }
  })], 1), _c('myinfo-row', {
    attrs: {
      "label": "이름"
    }
  }, [_c('v-text-field', {
    staticClass: "input rounded-0",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1), _c('myinfo-row', {
    attrs: {
      "label": "소속/부서"
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-0",
    attrs: {
      "type": "text",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.affiliation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "affiliation", $$v);
      },
      expression: "user.affiliation"
    }
  })], 1), _c('myinfo-row', {
    attrs: {
      "label": "자문분야"
    }
  }, _vm._l(_vm.areas, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child) {
      return _c('v-row', {
        key: child._id
      }, [_c('v-col', [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "label": child.name,
          "value": child._id,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "input": _vm.input
        },
        model: {
          value: _vm.user._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.user, "_areas", $$v);
          },
          expression: "user._areas"
        }
      })], 1), child.name == '기타(입력)' && _vm.user._areas.includes(child._id) ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        staticClass: "my-0 py-0",
        attrs: {
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: _vm.user.areas_manual[parent._id],
          callback: function callback($$v) {
            _vm.$set(_vm.user.areas_manual, parent._id, $$v);
          },
          expression: "user.areas_manual[parent._id]"
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  }), 1)], 1)])])]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('button', {
    staticClass: "button button--border-primary",
    on: {
      "click": function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', [_vm._v("취소하기")])]), _c('button', {
    staticClass: "button button--primary",
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_c('span', [_vm._v("회원가입")])])]), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": function change(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.user.postcode = postcode;
        _vm.user.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "text-20 text-lg-18"
  }, [_vm._v("기본정보")])]);
}]

export { render, staticRenderFns }